import Indicator from "../../../UI/Indicator/Indicator";
import './PumpPch.css';

export default function PumpPch({ 
        mode,
        status, 
        speed, 
        current,
        voltage,
        driveFault,
        faultDetails
    }) 
{
    return (
    <div className="pump-body"> 
        <table className="status-table">
        <thead>
            <tr>
                <th colspan="2" className="table-header">Состояние ПЧ</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td className="first-col">Режим работы</td>
                <td className="second-col">{mode}</td>
            </tr>
            <tr>
                <td className="first-col">Состояние</td>
                <td className={`second-col ${status==='Авария'? ("statusPchNA-error") :
                 (status==='В работе') ? ("statusPchNA-active"):("statusPchNA-warning")} `}>{status}</td>
            </tr>
            <tr>
                <td className="first-col">Скорость НА</td>
                <td className="second-col">{speed}</td>
            </tr>
            <tr>
                <td className="first-col">Ток</td>
                <td className="second-col">{current}</td>
            </tr>
            <tr>
                <td className="first-col">Напряжение сети</td>
                <td className="second-col">{voltage}</td>
            </tr>
            <tr className="indicator-row">
                <td colspan="2" className="full-width">
                    <div className="indicator-container alarm-pch">
                        <Indicator state={driveFault ? 'on' : 'off'} />
                        Авария ПЧ
                    </div>
                    <div className="alarm-details">{faultDetails}</div>
                </td>
            </tr>
        </tbody>
        </table>
    </div>
    )
}